<template>
  <PopupWrapper>
    <div v-if="emoji" class="popup-image">
      <span class="emoji">{{ emoji }}</span>
    </div>

    <PopupContent class="p-content">
      <h1 v-if="title" class="title">{{ title }}</h1>
      <p v-if="message" class="message">{{ message }}</p>
    </PopupContent>

    <PopupActions>
      <ButtonBase
        button-style="secondary"
        class="popup-button"
        @click.native="closePopup"
      >
        {{ $t('assets.button.cancel') }}
      </ButtonBase>
      <ButtonBase
        :button-style="buttonColor"
        class="popup-button"
        @click.native="confirm"
      >
        {{ $t('assets.button.confirm_action') }}
      </ButtonBase>
    </PopupActions>
  </PopupWrapper>
</template>

<script>
import PopupWrapper from '@assets/js/components/Popup/PopupWrapper'
import PopupActions from '@assets/js/components/Popup/PopupActions'
import PopupContent from '@assets/js/components/Popup/PopupContent'
import ButtonBase from '@assets/js/components/ButtonBase'
import { events } from '@main/js/bus'

export default {
  name: 'ConfirmPopup',
  components: {
    PopupWrapper,
    PopupActions,
    PopupContent,
    ButtonBase,
  },
  data() {
    return {
      confirmationData: [],
      message: undefined,
      title: undefined,
      emoji: undefined,
      buttonColor: undefined,
    }
  },
  mounted() {
    // Show confirm (use a global flag to prevent multiple instances)
    events.$on('confirm:open', (args) => {
      // Only the first mounted instance should handle this
      if (window.__confirmPopupHandled) return
      window.__confirmPopupHandled = true

      this.title = args.title
      this.message = args.message
      this.emoji = ''
      this.confirmationData = args.action
      this.buttonColor = 'danger-solid'

      if (args.buttonColor) {
        this.buttonColor = args.buttonColor
      }

      // Reset flag after popup closes
      setTimeout(() => {
        window.__confirmPopupHandled = false
      }, 100)
    })
  },
  methods: {
    closePopup() {
      events.$emit('popup:close')
    },
    confirm() {
      // Close popup
      events.$emit('popup:close')

      // Confirmation popup
      events.$emit('action:confirmed', this.confirmationData)

      // Clear confirmation data
      this.confirmationData = []
    },
  },
}
</script>

<style scoped lang="scss">
.popup-image {
  padding-top: 20px;
  text-align: center;
  margin-bottom: 20px;

  .emoji {
    @include font-size(56);
    line-height: 1;
  }
}

.p-content {
  text-align: center;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;

  .title {
    @include font-size(18);
    text-transform: uppercase;
    font-weight: 800;
    color: $text;
    margin-bottom: 20px;
  }

  .message {
    @include font-size(16);
    color: #333;
    margin-top: 5px;
  }
}

@media only screen and (max-width: 690px) {
  .content {
    top: 110px;
  }
}

// Dark mode disabled
// @media (prefers-color-scheme: dark) {
//   .content {
//     .title {
//       color: $dark_mode_text_primary;
//     }
//
//     .message {
//       color: $dark_mode_text_secondary;
//     }
//   }
// }
</style>
